import React from 'react';
import './blockchainCTA.css';

const BlockchainCTA = () => {
  return (
    <>
      <section className="background">
        <div data-testid="button" className="cta-button">Join the Network</div>
      </section>
    </>
  );
};

export default BlockchainCTA;